import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PRESERVE_HTTP_ERROR } from '../../shared/utils/preserve-http-error.context';

export interface OrderTransferCancellationPreview {
  orderId: number;
  orderProductId: number;
  movingDocId?: number;
  sourceWarehouse?: string;
  targetWarehouse: string;
  quantity: number;
  pickedQuantity: number;
  shelfReturnQuantity?: number;
  expectedState: string;
}

@Injectable({ providedIn: 'root' })
export class OrderTransferCancellationService {
  constructor(private http: HttpClient) {}

  private url(orderId: number, orderProductId: number) {
    return `${environment.BACKEND}/order/${orderId}/products/${orderProductId}/transfer-cancellation`;
  }

  prepare(orderId: number, orderProductId: number, movingDocId?: number) {
    return this.http.post<OrderTransferCancellationPreview>(
      `${this.url(orderId, orderProductId)}/preview`, { movingDocId },
      { context: new HttpContext().set(PRESERVE_HTTP_ERROR, true) }
    ).toPromise();
  }

  cancel(preview: OrderTransferCancellationPreview, reason: string, operationId: string) {
    return this.http.post(this.url(preview.orderId, preview.orderProductId), {
      movingDocId: preview.movingDocId, expectedState: preview.expectedState,
      reason: reason.trim(), operationId
    }, { context: new HttpContext().set(PRESERVE_HTTP_ERROR, true) });
  }

  operationId() {
    const values = new Uint8Array(16);
    window.crypto.getRandomValues(values);
    values[6] = (values[6] & 0x0f) | 0x40;
    values[8] = (values[8] & 0x3f) | 0x80;
    const hex = Array.from(values, value => value.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  }
}
